import api from './api';

/** Pragya Adaptive Edge Engine API client. */
export const edgeService = {
  getConfig: () => api.get('/edge/config'),
  updateConfig: (patch: Record<string, any>) => api.put('/edge/config', patch),
  getStats: () => api.get('/edge/stats'),
  getBoard: (horizon = 'NEXT_DAY') => api.get('/edge/board', { params: { horizon } }),
  getModel: (horizon = 'NEXT_DAY') => api.get('/edge/model', { params: { horizon } }),
  getAccuracy: (horizon = 'NEXT_DAY') => api.get('/edge/accuracy', { params: { horizon } }),
  getTrackRecord: (horizon = 'NEXT_DAY') => api.get('/edge/track-record', { params: { horizon } }),
  getAutoTrade: () => api.get('/edge/autotrade'),
  getOptionTrades: (generate = false) => api.get('/edge/option-trades', { params: generate ? { generate: 1 } : {} }),
  getUniverseOptions: () => api.get('/edge/universe-options'),
  getRange: () => api.get('/edge/range'),
  rangeRebuild: () => api.post('/edge/range/rebuild'),
  getSymbol: (symbol: string) => api.get(`/edge/symbol/${encodeURIComponent(symbol)}`),
  capture: () => api.post('/edge/capture'),
  label: () => api.post('/edge/label'),
  retrain: () => api.post('/edge/retrain'),
  backfill: (days: number) => api.post('/edge/backfill', { days }),
};
